<script>
export default {
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<template>
  <div :class="$style.faqContainer" data-question-block>
    <div :class="$style.heading" @click="toggleOpen">
      <p class="button-text motto-blue-text">{{ question }}</p>
      <BaseIcon
        :class="{
          [$style.chevronIcon]: true,
          'color-gray': !isOpen,
          'color-secondary-green': isOpen,
        }"
        :name="isOpen ? 'chevron-up' : 'chevron-down'"></BaseIcon>
    </div>
    <Transition name="slide-y">
      <div v-if="isOpen" :class="$style.content">
        <p class="p1" v-html="answer" />
        <img v-if="imageUrl" :class="$style.thumbnail" :src="imageUrl" alt="Question Image" />
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.faqContainer {
  @media (max-width: $lg-breakpoint) {
    margin: 0 auto;
  }

  padding: 16px 24px;
  border: 1px solid $lightest-gray;
  border-radius: 8px;
}

.heading {
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  p {
    width: 90%;
    line-height: 15px;
  }
}

.chevronIcon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 22px;
}

.content {
  margin-top: 16px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.thumbnail {
  width: 100%;
  margin-top: 16px;
  border-radius: 4px;
}
</style>
